import React from 'react';
import { TrendingUp, TrendingDown } from 'lucide-react';
import { StatTrendResult } from '../utils/statTrends';

interface StatTrendIndicatorProps {
  trend: StatTrendResult;
  showText?: boolean;
  size?: 'sm' | 'md' | 'lg';
}

export const StatTrendIndicator: React.FC<StatTrendIndicatorProps> = ({
  trend,
  showText = true,
  size = 'md',
}) => {
  const isUp = trend.isUp;
  const Icon = isUp ? TrendingUp : TrendingDown;

  const iconSizes = {
    sm: 'w-3 h-3',
    md: 'w-4 h-4',
    lg: 'w-5 h-5',
  };

  const textSizes = {
    sm: 'text-[9px]',
    md: 'text-[10px]',
    lg: 'text-xs',
  };

  return (
    <div
      className={`inline-flex items-center space-x-1 px-1.5 py-0.5 rounded-md font-mono font-extrabold ${
        isUp
          ? 'bg-emerald-500/20 text-emerald-400 border border-emerald-500/30'
          : 'bg-rose-500/20 text-rose-400 border border-rose-500/30'
      }`}
      title={`Last 3 Games Avg: ${trend.recentAvg} vs Overall Avg: ${trend.overallAvg}`}
    >
      <Icon className={`${iconSizes[size]} ${isUp ? 'text-emerald-400' : 'text-rose-400'} shrink-0`} />
      {showText && <span className={`${textSizes[size]} whitespace-nowrap`}>{trend.deltaText}</span>}
    </div>
  );
};
